import { Button, FormControl, Grid, Group, IconButton, Tab, Layout, Page } from "@/comn/components";
import {
    useAuth,
    useFetch,
    useForm,
    useGrid,
    useTab,
    useModal,
    usePage,
    useResource,
    useStore,
    useToast,
} from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    APIS,
    URLS,
    SF_ALTER_MGR_INFO,
    SF_ALTER_RVCR_INFO,
    SG_ALTER_MGR_LIST,
    SG_ALTER_RVCR_DEPT_LIST,
    SG_ALTER_RVCR_ID_LIST,
} from "@/tra/tancis/ptli/ewc/svr/services/EwciAlterMgrService";

/*
 * Alert Receiver Management Details
 * !== 경고 수신자 관리 상세 ==!
 */
export const EWCI1001009S = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();
    const location = useLocation();
    const dtlData = location.state || {};

    useResource({
        defaultSchema: [
            { area: "cstmOfcrCd" },
            { area: "cstmOrgzCd" },
            { area: "comnCd", comnCd: "COM0064" },
            { area: "comnCd", comnCd: "PTL0020" },
        ],
    });

    const tab = useTab({
        defaultSchema: {
            id: "tab_fee",
            schema: [{ label: t("L_RCVR_DEPT_CD") }, { label: t("L_RCVR_ID") }],
        },
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        alterMgrInfo: useForm({
            defaultSchema: SF_ALTER_MGR_INFO,
            defaultValues: { ...dtlData, description: dtlData.annotations.description } || {},
        }),
    };

    const grid = {
        alterRcvrDeptList: useGrid({
            defaultSchema: SG_ALTER_RVCR_DEPT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        alterRcvrIdList: useGrid({
            defaultSchema: SG_ALTER_RVCR_ID_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Get Alert Receiver Management List. !== EWACS 경고 목록 조회.==!
        getAlrtRecptMgmtList: useFetch({
            api: (data) => {
                const alrtId = dtlData.uid;
                return APIS.getAlrtRecptMgmtList(alrtId);
            },
            enabled: !!dtlData,
            onSuccess: (data) => {
                console.log(data.recptList.content.length);

                let recptIdList = [];
                let recptDeptCdList = [];

                for (let i = 0; i < data.recptList.content.length; i++) {
                    if (data.recptList.content[i].recptId != null) {
                        recptIdList.push(data.recptList.content[i]);
                    } else if (data.recptList.content[i].recptDeptCd != null) {
                        recptDeptCdList.push(data.recptList.content[i]);
                    }
                }

                console.log(data.recptList.content);
                console.log(recptIdList);
                grid.alterRcvrIdList.setData(comnUtils.getGridData([...recptIdList]));
                grid.alterRcvrDeptList.setData(comnUtils.getGridData([...recptDeptCdList]));
            },
            onError: () => {},
            showToast: true,
        }),
        // Save Alert Receiver Management List. !== EWACS 경고 목록 저장.==!
        saveAlterRcvrDeptList: useFetch({
            api: (data) => {
                console.log(data);
                return APIS.saveAlterMgr(data);
            },
            onSuccess: (data: any) => {
                modal.openModal({
                    content: "msg.00003",
                });
                console.log(data);
                navigate(URLS.ewci1001007q);
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.alterMgrInfo.setErrors(error.response.data.errors);
                }
                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
    };

    const handler = {
        saveAlterRcvrDeptList: () => {
            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    const data = [...grid.alterRcvrDeptList.getData(), ...grid.alterRcvrIdList.getData()];

                    console.log(data);
                    //grid.alterRcvrDeptList.getData();
                    fetch.saveAlterRcvrDeptList.fetch(data);
                },
            });
        },
        // Event - Delete Grid Item list !== 그리드 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridalterRcvrDeptList: () => {
            const seltList: any[] = grid.alterRcvrDeptList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }
            grid.alterRcvrDeptList.deleteRow("checkbox");
        },
        click_Btn_DeleteGridalterRcvrIdList: () => {
            const seltList: any[] = grid.alterRcvrIdList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }
            grid.alterRcvrIdList.deleteRow("checkbox");
        },
    };

    const render = {
        grid_alterMgrList: {
            edit: {
                deptOfcrCrgeSett: (props: any) => {
                    const { binding, control, rowValues, value } = props;

                    return (
                        <FormControl
                            type="select"
                            options={[
                                { label: "L_DEPT", value: "DEPT" },
                                { label: "L_CHPN", value: "CHPN" },
                            ]}
                            value={value}
                            onChange={(_value) => {
                                grid.alterRcvrDeptList.updateRow({ ...rowValues, deptOfcrCrgeSett: _value });
                            }}
                        />
                    );
                },
                recptId: (props: any) => {
                    const { binding, control, rowValues, value } = props;

                    if (rowValues.deptOfcrCrgeSett === "CHPN") {
                        return (
                            <FormControl
                                type="code"
                                area="cstmOfcrCd"
                                value={value}
                                onChange={(_value) => {
                                    grid.alterRcvrDeptList.updateRow({ ...rowValues, recptId: _value });
                                }}
                            />
                        );
                    } else {
                        return <></>;
                    }
                },
                recptDeptCd: (props: any) => {
                    const { binding, control, rowValues, value } = props;
                    if (rowValues.deptOfcrCrgeSett === "DEPT") {
                        return (
                            <FormControl
                                type="code"
                                area="cstmOrgzCd"
                                value={value}
                                onChange={(_value) => {
                                    grid.alterRcvrDeptList.updateRow({ ...rowValues, recptDeptCd: _value });
                                }}
                            />
                        );
                    } else {
                        return <></>;
                    }
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.alterMgrInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout.Left>
                            <Group.Title title={"T_ALT_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>

                    <Layout direction="col">
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.alterMgrInfo.schema.uid}></Group.Control>
                                <Group.Control {...form.alterMgrInfo.schema.title}></Group.Control>
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.alterMgrInfo.schema.condition}></Group.Control>
                                <Group.Control {...form.alterMgrInfo.schema.updated}></Group.Control>
                            </Group.Row>

                            <Group.Row>
                                <Group.Control
                                    {...form.alterMgrInfo.schema.description}
                                    controlSize={10}
                                ></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Tab {...tab.tab}>
                        <Tab.Panel>
                            <Layout direction="col" gap={2}>
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"L_DEPT_OFCR_CRGE_SETT"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                    <Layout.Right>
                                        <Button
                                            role="gridAdd"
                                            onClick={() => grid.alterRcvrDeptList.addRow({ alrtId: dtlData.uid })}
                                        ></Button>
                                        <Button
                                            role="gridDelete"
                                            onClick={() => {
                                                handler.click_Btn_DeleteGridalterRcvrDeptList();
                                            }}
                                        ></Button>
                                    </Layout.Right>
                                </Layout>
                                <Group.Section>
                                    <Grid
                                        {...grid.alterRcvrDeptList.grid}
                                        //data={fetch.getAlrtRecptMgmtList.data?.recptList}
                                    />
                                </Group.Section>
                            </Layout>
                        </Tab.Panel>

                        <Tab.Panel>
                            <Layout direction="col" gap={2}>
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"L_DEPT_OFCR_CRGE_SETT"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                    <Layout.Right>
                                        <Button
                                            role="gridAdd"
                                            onClick={() => grid.alterRcvrIdList.addRow({ alrtId: dtlData.uid })}
                                        ></Button>
                                        <Button
                                            role="gridDelete"
                                            onClick={() => {
                                                handler.click_Btn_DeleteGridalterRcvrIdList();
                                            }}
                                        ></Button>
                                    </Layout.Right>
                                </Layout>
                                <Group.Section>
                                    <Grid
                                        {...grid.alterRcvrIdList.grid}
                                        //data={fetch.getAlrtRecptMgmtList.data?.recptList}
                                    />
                                </Group.Section>
                            </Layout>
                        </Tab.Panel>
                    </Tab>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button role="list" onClick={() => navigate(URLS.ewci1001007q)} />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.saveAlterRcvrDeptList();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
